import { CALL_API } from 'redux-api-middleware';

export const LOGOUT_REQUEST = Symbol('AUTH_LOGOUT_REQUEST');
export const LOGOUT_SUCCESS = Symbol('AUTH_LOGOUT_SUCCESS');
export const LOGOUT_FAILED = Symbol('AUTH_LOGOUT_FAILED');

export function logout() {
	return {
		[CALL_API]: {
			endpoint: `${process.env.API_URI}/logout`,
			method: 'POST',
			headers: {
				'Accept': 'application/json'
			},
			types: [
				LOGOUT_REQUEST,
				LOGOUT_SUCCESS,
				LOGOUT_FAILED
			]
		},
	};
}
